// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-container {
  background: #23232b;
  padding: 2rem;
  border-radius: 10px;
  color: #fff;
}
.tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.tabs button {
  background: #3a3a47;
  color: #fff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  cursor: pointer;
}
.tabs button.active {
  background: #b48a3a;
  color: #23232b;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/failed-payments-management/failed-payments-management.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".panel-container {\n  background: #23232b;\n  padding: 2rem;\n  border-radius: 10px;\n  color: #fff;\n}\n.tabs {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n.tabs button {\n  background: #3a3a47;\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.tabs button.active {\n  background: #b48a3a;\n  color: #23232b;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
